import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";
export const batchApi = createApi({
  reducerPath: "batchApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getBatch: builder.query({
      query: () => ({
        url: "/batch",
        method: "GET",
      }),
      providesTags: ["Batch"],
    }),
    saveBatch: builder.mutation({
      query: ({ Token, formData }) => ({
        url: "/batch",
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: formData,
      }),
      invalidatesTags: ["Batch"],
    }),

    UpdateBatch: builder.mutation({
      query: ({ id, Token, formData }) => ({
        url: `/batch/${id}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
        body: formData,
      }),
      invalidatesTags: ["Batch"],
    }),
    DeleteBatch: builder.mutation({
      query: ({ id, Token }) => ({
        url: `/batch/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      invalidatesTags: ["Batch"],
    }),
  }),
});

export const {
  useGetBatchQuery,
  useSaveBatchMutation,
  useUpdateBatchMutation,
  useDeleteBatchMutation,
} = batchApi;
